<h5 class="text-primary mb-3">Media</h5>
<div class="row g-0">
  <div class="col-lg-3">
    <era-media-state [mediaState]="mediaState$ | async"></era-media-state>
  </div>
  <div class="col">
    <era-player [mediaState]="mediaState$ | async"></era-player>
  </div>
  @if (movie$ | async) {
    <div class="col-xl-5">
      <era-movie [movie]="movie$ | async"></era-movie>
    </div>
  } @if (tvChannel$ | async) {
    <div class="col-xl-5">
      <era-tv-channel [tvChannel]="tvChannel$ | async"></era-tv-channel>
    </div>
  } @if (radioChannel$ | async) {
    <div class="col-xl-5">
      <era-radio-channel [radioChannel]="radioChannel$ | async"></era-radio-channel>
    </div>
  }
</div>